export interface TutorialItem { path: string; title: string; group: string }
export const tutorialGroups = ['认识管理端', '基础设置', '客户与会员', '商品与内容', '订单处理', '审核与通知', '数据与维护']
export const tutorialGroup = (path: string): string => {
  if (/messages|notices|banner|audited|auditsettings/i.test(path)) return tutorialGroups[5]
  if (/platforminfo|settings|branchlist|merchants|orgs|skin/i.test(path)) return tutorialGroups[1]
  if (/^\/customers\//i.test(path)) return tutorialGroups[2]
  if (/^\/products\/|category/i.test(path)) return tutorialGroups[3]
  if (/^\/orders\//i.test(path)) return tutorialGroups[4]
  return tutorialGroups[6]
}
export const tutorialCatalog = (menus: any[], parents: any[]): TutorialItem[] => {
  const parentIds = new Set(parents.filter(p => Number(p.parentId) === 0).map(p => Number(p.id)))
  const seen = new Set<string>()
  return menus.filter(item => item.functionType === 'MENU' && parentIds.has(Number(item.parentId)))
    .sort((a,b) => Number(a.sortIndex || 0) - Number(b.sortIndex || 0))
    .filter(item => {
      const path = String(item.functionUrl || '')
      if (!/^\/[a-zA-Z0-9_][a-zA-Z0-9_/-]*$/.test(path) || seen.has(path)) return false
      seen.add(path); return true
    }).map(item => ({path:item.functionUrl, title:item.functionName, group:tutorialGroup(item.functionUrl)}))
}
export const tutorialStorageKey = (user: any): string => {
  const identity = user?.id || user?.userId || user?.loginName
  return user?.orgId && identity ? `admin-tutorial:v1:${encodeURIComponent(String(user.orgId))}:${encodeURIComponent(String(identity))}:${encodeURIComponent(String(user.roleId || ''))}` : ''
}
